import { TipoSolucoesService } from 'core/http/service/TipoSolucoes.service';
import TipoSolucoesDTO from 'models/solucoes/TipoSolucoesDTO';
import { useQuery } from 'react-query';

const service = new TipoSolucoesService();

const fetchSolutions = async (): Promise<TipoSolucoesDTO[]> => {
    const response = await service.getAll();
    return response.data;
};

export function useSolutions() {
    const listQuerySolutions = useQuery('listSolutions', fetchSolutions);

    return {
        listQuerySolutions,
    };
}
